// extracted by mini-css-extract-plugin
export default {"marker":"map-marker_marker__p3tJk","popup":"map-marker_popup__X+0tw","popupContent":"map-marker_popupContent__xPJax"};